import { Tag } from '@wheely/ui-kit';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { IJourney } from '@/modules/journey/model';
import { getStatusIntent } from '@/shared/utils/getStatusIntent';
import { renderStatus } from '@/shared/utils/renderStatus';
import { StepLayout } from '@/shared/view/StepLayout';

import { Breakdown } from './components/Breakdown';
import { HeaderDetails } from './components/HeaderDetails';
import { History } from './components/History';
import { JourneyDetails } from './components/JourneyDetails';

interface IProps {
  journey: IJourney;
  onClickBack: () => void;
}

const View = ({ journey, onClickBack }: IProps) => {
  const intl = useIntl();

  return (
    <div>
      <StepLayout
        onClickBack={onClickBack}
        title={
          <FormattedMessage
            defaultMessage={`Journey #{number}`}
            id="mwjSP0"
            description="Journey screen: main title"
            values={{ number: journey.number }}
          />
        }
        subTitle={
          <Tag intent={getStatusIntent(journey.status)}>{renderStatus(journey.status, intl)}</Tag>
        }
        hideProgress={true}
      >
        <HeaderDetails journey={journey} />
        <JourneyDetails journey={journey} />
        {(Boolean(journey?.breakdown?.length) || journey.isTotalDefined) && (
          <Breakdown journey={journey} />
        )}
        {journey.events && <History journey={journey} />}
      </StepLayout>
    </div>
  );
};

export { View };
